import React from 'react';
import { observer } from 'mobx-react';
import { Switch } from 'react-router-dom';

import { getTopLevelRoutes } from 'ui/TopLevelRoutes';
import { useGlobalContext } from 'hooks';

const AppRoutes = () => {
  const { clientData, serverData, clientDataHolder } = useGlobalContext();
  const frontendRoutes = getTopLevelRoutes(clientData, serverData, clientDataHolder);

  return <Switch>{frontendRoutes}</Switch>;
};

export default observer(AppRoutes);
